<template>
  <div class="contracts-register-row">
    <span class="contracts-register-row__code ms-ellipsis ms-small-head">
      {{ project.code }}
    </span>
    <span class="contracts-register-row__name ms-text">
      <ellipsis-text :max-width="320" :text="project.name" />
    </span>
    <span class="contracts-register-row__performer ms-ellipsis ms-help">
      {{ project.performer_name }}
    </span>
    <span class="contracts-register-row__costs">
      <tag class="ms-costs" color="primary">
        {{ getFormattedCosts(project.costs, false, project.with_vat) }}
      </tag>
    </span>
    <span class="contracts-register-row__dates ms-help">
      <tag>{{ formatDefaultDate(project.start_date) }}</tag>
    </span>
    <div class="contracts-register-row__customer ms-text">
      <tag :color="getContractStatusColor(project.contract_status_name)">
        {{ project.contract_status_name }}
      </tag>
    </div>
  </div>
</template>

<script>
import {
  getFormattedCosts,
  getContractStatusColor,
  formatDefaultDate
} from '@/utils'
import EllipsisText from '@/components/parts/ellipsis-text'

export default {
  props: ['project'],
  components: {
    EllipsisText
  },
  methods: {
    getFormattedCosts,
    getContractStatusColor,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.contracts-register-row {
  display: flex;
  align-items: center;
  flex: 1;
  padding-right: 16px;

  &__code {
    margin-right: 4px;
    width: 100px;
  }

  &__name {
    display: inline-block;
    width: 320px;
    margin-right: 16px;
  }

  &__performer {
    display: inline-block;
    width: 120px;
  }

  &__costs {
    margin-left: 16px;

    .ivu-tag {
      width: 200px;
      text-align: center;
    }
  }

  &__dates {
    margin-left: 16px;

    .ivu-tag {
      background: #fff;
    }
  }

  &__customer {
    margin-left: auto;
  }
}
</style>
